.accommodationBlockingOverview {
  width: 100%;

  td,
  th {
    padding: 0.5rem;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.columnToggler {
  min-width: 15rem;
}

.headerActions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dataTableContainer {
  margin-top: 1rem;
}

.actionsCell {
  display: flex;
  gap: 0.25rem;
}

.statusPending {
  color: #b58900;
  font-weight: 600;
}

.statusProcessed {
  color: #2e7d32;
  font-weight: 600;
}

.dateToOpenDateFilter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
